import {SpaceHome} from "./system/home";
import {SpaceProjects} from "./system/projects";
import {Workspaces} from "./workspaces/workspaces";
import {SpaceProto} from "./space-proto";
import {SpaceUsers} from "./system/users";
import {SpaceCrm} from "./system/crm";
import {SpaceReports} from "./system/reports";
import {SpaceTools} from "./system/tools";
import {SpaceSettings} from "./system/settings";
import NavigationSection from "../navigation/navigation-section";
import Workspace from "./workspaces/workspace";
import {sortByIds} from "../../gd/utils/sort/sort-by-ids";
import {SpaceChats} from "./system/chats";
import {SpaceMyAccount} from "./system/my-account";
import {SpaceHelp} from "./system/help";
import {SpaceSearch} from "./system/search";
import {SpaceQuickAdd} from "./system/quick-add";
import {SpaceAIChat} from "./system/ai-chat";
import {NavigationButtonPosition, NavigationSectionType} from "../navigation/@const";

// const debug = "Spaces"
const debug = false

export class Spaces {

    public home         : SpaceHome
    public projects     : SpaceProjects
    public users        : SpaceUsers
    public crm          : SpaceCrm
    public reports      : SpaceReports
    public tools        : SpaceTools
    public settings     : SpaceSettings
    public chats        : SpaceChats
    public myAccount    : SpaceMyAccount
    public help         : SpaceHelp
    public search       : SpaceSearch
    public quickAdd     : SpaceQuickAdd
    public aiChat       : SpaceAIChat

    public workspaces   : Workspaces

    private systemSpaces    : SpaceProto[]  = []


    constructor() {
        debug && console.log(debug, "constructor()")

        // gd.session.projects.initTree()

        this.home           = new SpaceHome()
        this.projects       = new SpaceProjects()
        this.users          = new SpaceUsers()
        this.crm            = new SpaceCrm()
        this.reports        = new SpaceReports()
        this.tools          = new SpaceTools()
        this.settings       = new SpaceSettings()
        this.chats          = new SpaceChats()
        this.myAccount      = new SpaceMyAccount()
        this.help           = new SpaceHelp()
        this.search         = new SpaceSearch()
        this.quickAdd       = new SpaceQuickAdd()
        this.aiChat         = new SpaceAIChat()

        this.workspaces     = new Workspaces()

        this.systemSpaces   = [
            this.projects,
            this.users,
            this.crm,
            this.reports,
            this.tools,
            this.chats,
            this.home,
            this.settings,
            this.myAccount,
            this.help,
            this.search,
            this.quickAdd,
            this.aiChat,
        ]
    }

    // Asana

    get current():SpaceProto {
        return gd.layout.navigation.state.currentSection?.space || this.default
    }

    get default():SpaceProto {
        return this.asanaSpaces[0]
    }

    // End

    removeNavigationStructure() {
        _.each(this.systemSpaces, (space:SpaceProto)=>{
            space.removeNavigation()
        })

        _.map(this.workspaces.models, workspace => {
            workspace.removeNavigation()
        })
    }

    initNavigationStructure() {

        // init main system spaces (except for chats to make chats LAST)
        _.each(this.systemSpaces, (space:SpaceProto)=>{
            space.initNavigation()
        })

        _.map(this.workspaces.models, workspace => {
            workspace.initNavigation()
        })

        // gd.navigationStructure.debug()
    }

    // used in asana skin
    get asanaSpaces():SpaceProto[] {

        let spaces : SpaceProto[] = [
            gd.spaces.home,
            this.projects,
        ]

        _.map(this.workspaces.models, (workspace: Workspace) => {
            spaces.push(workspace)
        })

        spaces = _.concat(spaces, [
            // this.chats, // ???
            this.crm,
            this.tools,
            this.reports,
            this.users,
        ])

        return spaces
    }

    // Sorted !!! - without home space ...
    get allSpaces():SpaceProto[] {
        let spaces : SpaceProto[] = []

        _.map(this.systemSpaces, (space: SpaceProto) => {
            if (space.inNavigationPanel) {
                spaces.push(space)
            }
        })

        _.map(this.workspaces.models, (workspace: Workspace) => {
            if (workspace.inNavigationPanel) {
                spaces.push(workspace)
            }
        })

        spaces = sortByIds(spaces, gd.user.settings.navigation.spacesSorting)

        return spaces
    }

    get spacesWithProjects(): SpaceProto[] {
        let spaces : SpaceProto[] = []

        _.map(this.systemSpaces, (space: SpaceProto) => {
            if (space.canHaveProjects) {
                spaces.push(space)
            }
        })

        _.map(this.workspaces.models, (workspace: Workspace) => {
            if (workspace.canHaveProjects) {
                spaces.push(workspace)
            }
        })

        spaces = sortByIds(spaces, gd.user.settings.navigation.spacesSorting)

        return spaces
    }


    get navigationPanelTopSpaces():SpaceProto[] {

        const spaces : SpaceProto[] = _.filter(gd.spaces.allSpaces, (space: SpaceProto) => {

            return !space.navigation.hiddenToMore
                && space.position === NavigationButtonPosition.TOP
                && space.id != NavigationSectionType.QUICK_ADD
        })

        return spaces

    }

    get navigationPanelTopSpacesAsNavigations():NavigationSection[] {

        let spaces : SpaceProto[] = _.filter(gd.spaces.allSpaces, (space: SpaceProto) => {

            return space.position === NavigationButtonPosition.TOP
                && space.id !== NavigationSectionType.QUICK_ADD
                && !space.navigation.hiddenToMore
        })

        spaces = sortByIds(spaces, gd.user.settings.navigation.spacesSorting)

        let navigations = _.map(spaces, (space)=>{ return space.navigation})

        return navigations
    }


    get navigationPanelSections():NavigationSection[] {

        const result : NavigationSection[] = _.map(this.allSpaces, (space)=>{
            return space.navigation
        })

        return result
    }

    get navigationMoreSpaces():SpaceProto[] {

        const spaces : SpaceProto[] = []

        if (gd.spaces.projects.inNavigationMore) {
            spaces.push(gd.spaces.projects)
        }

        _.map(this.workspaces.models, (workspace: Workspace) => {
            if (workspace.inNavigationMore) {
                spaces.push(workspace)
            }
        })

        // Commented for new Design of Navbar more popover
        // _.map(this.systemSpaces, (space:SpaceProto) => {
        //     if (space.inNavigationMore) {
        //         spaces.push(space)
        //     }
        // })

        return spaces
    }

    get navigationMoreSections():NavigationSection[] {


        const result : NavigationSection[] = _.map(this.navigationMoreSpaces, (space)=>{
            return space.navigation
        })


        return result
    }



    saveSpacesOrder(sections:NavigationSection[]) {

        const ids : string[]    = _.map(sections, (section)=>{
            return section.id
        })

        gd.user.settings.navigation.spacesSorting = ids
        gd.user.settings.save()
    }




}
